// test427
(427 && 0);
